<template>
  <div class="form-group">
    <slot name="label">
      <label v-if="label" class="control-label">
        {{label}}
      </label>
    </slot>

    <div class="select-wrapper d-flex" :class="{ske}">
      <div class="select-inner-wrapper">
        <span class="form-select form-control" :class="{showing}" @click="showing = !showing">
          <slot></slot>
        </span>

        <div v-if="showing" class="dropdown-menu p-2">
          <div class="d-flex align-items-center">
            Percentage

            <FormPercentageInput
              v-model="vuelidate.discount_percentage.$model"

              class="ml-3"
              :ske="true"
              :vuelidate="vuelidate"
              fieldName="discount_percentage"

              id="discount_percentage"
            />
          </div>
          <div class="d-flex align-items-center mt-2">
            Bedrag

            <FormPriceInput
              v-model="vuelidate.amount.$model"

              class="ml-3"
              :ske="true"
              :vuelidate="vuelidate"
              fieldName="amount"

              id="amount"
            />
          </div>
        </div>

        <span class="arrow" :class="{showing}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

import FormPriceInput from "../../../Inputs/FormPriceInput.vue"
import FormPercentageInput from "../../../Inputs/FormPercentageInput.vue"

export default {
  components: {
    FormPriceInput,
    FormPercentageInput,
  },
  props: {
    ske: Boolean,
    label: String,

    vuelidate: Object,
  },
  data() {
    return {
      showing: false,
    }
  },
  methods: {
    checkPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (node === this.$el) {
          found = true
          break
        }
      }
      if (!found) this.showing = false
    },
  },
  watch: {
    showing(val) {
      if (val) {
        window.addEventListener("click", this.checkPath, {passive: true})
      } else {
        window.removeEventListener("click", this.checkPath)
      }
    }
  },
}

</script>

<style scoped>

.form-control {
  white-space: nowrap !important;
}

.form-control > span {
  display: inline-block;
  transform: translateY(2px);
}

.dropdown-menu {
  display: block !important;
  opacity: 1;
  visibility: visible !important;
  border: 1px solid var(--mint-green);
  padding-bottom: 8px;
  border-radius: 1px;
  min-width: 16em;
}


.select-wrapper {
  position: relative;
}

.select-inner-wrapper {
  flex-basis: 100%;
  position: relative;
}

.arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  color: #E3E3E3;
}

.arrow, svg {
  transition-duration: .15s;
}

.form-select {
  cursor: default !important;
  padding-right: 32px !important;
}

.select-inner-wrapper:hover {
  background-color: var(--mint-green);
}

.form-group {
  margin: 0px;
}

.form-control.showing {
  border: 1px solid #aaa;
}

.showing {
  color: #212529;
}

svg {
  transform: rotate(0deg);
}

.showing svg {
  transform: rotate(-90deg);
}


</style>
